import { useTranslation } from "react-i18next";
import { Button } from "antd";
import { ReactComponent as Success } from "assets/icons/success.svg";
import { ReactComponent as Failed } from "assets/icons/failed.svg";

import config from "utils/globals";

const Receipt = ({ amount, status, trace_no, onClose }) => {
  const { t } = useTranslation();
  const isSuccess = status === "SUCCESS";

  return (
    <>
      <div className="flex flex-col  px-4 py-5 bg-white  shadow-lg rounded-lg mt-14 mx-4">
        <div className="w-[90px] h-[90px] table m-auto ">
          <div className="w-[90px] h-[90px] relative flex justify-center items-center p-[14px]">
            {isSuccess ? (
              <Success className="w-[90px] h-[90px]" />
            ) : (
              <Failed className="w-[90px] h-[90px]" />
            )}
          </div>
        </div>
        <div
          className={`text-center ${isSuccess ? "text-primary-0" : "text-error-0"
            }  body-16px-medium mb-2 pt-4 pb-6 border-b border-dotted border-b-gray--6`}
        >
          {isSuccess
            ? t("pma-onboarding.submit-successful")
            : t("pma-onboarding.submit-failed")}
        </div>

        <div div className="px-3 py-4 bg-gray--12 rounded-lg my-6 ">
          {![undefined, null, ""].includes(amount) && (
            <div className="  flex justify-between items-center">
              <span className="body-14px-regular text-gray-0 ">
                {t("amount")}
              </span>
              <span className="flex gap-1 text-gray-4 body-16px-medium ">
                {config.numberSeparator(amount)}
                <span className="body-14px-regular">{t("rial")}</span>
              </span>
            </div>
          )}
          {![undefined, null, ""].includes(trace_no) && (
            <div
              className={`flex gap-1 items-center flex-wrap justify-between caption-12px-medium text-gray-0`}
            >
              <span className="body-14px-regular text-gray-0 min-w-24">
                {t("pma-onboarding.transaction-code")}
              </span>
              <span className=" text-gray-4 body-16px-medium">{trace_no}</span>
            </div>
          )}
        </div>
      </div>
      <div className="p-5 fixed bottom-0 max-w-2xl w-full">
        <Button
          block
          className={`default-button-large min-h-[46px] justify-center items-center`}
          onClick={onClose}
        >
          {t("close")}
        </Button>
      </div>
    </>
  );
};

export default Receipt;
